// Login ke baad kahan wapas jaana hai (cart → login → checkout).
// sessionStorage me, taaki signup → OTP → login ke beech bhi bacha rahe.
const KEY = "ci_next";

export const setNextAfterLogin = (path: string): void => {
  try {
    sessionStorage.setItem(KEY, path);
  } catch (e) {
    // private window — koi baat nahi
  }
};

/** Path deta hai aur mita deta hai; kuch na ho to "/" */
export const consumeNextAfterLogin = (): string => {
  try {
    const v = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return v && v.startsWith("/") ? v : "/";
  } catch (e) {
    return "/";
  }
};
